import { useContext } from 'react';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ButtonBase } from '@mui/material';

import { VisibilityContext } from '@/components/Chart/FullScreenChart/FullScreenLegend/LegendItem/VisibilityContext';
import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';

const VisibilityToggleButton = ({ series }: { series: ExtendedSeriesOptionsType }) => {
  const { toggleSeriesVisibility } = useContext(VisibilityContext);

  return (
    <ButtonBase
      onClick={() => {
        toggleSeriesVisibility(series.id as string);
      }}
    >
      {series.visible ? <Visibility fontSize='small' /> : <VisibilityOff fontSize='small' />}
    </ButtonBase>
  );
};
export default VisibilityToggleButton;
